import { SvgIcon, SvgIconProps } from '@mui/material';

export const VestIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 17">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.06979 0H3V6C3 7.10457 2.10457 8 1 8H0V17H6.875V8.125L5.06979 0ZM9.125 17H16V8H15C13.8954 8 13 7.10457 13 6V0H10.9302L9.125 8.125V17Z"
    />
  </SvgIcon>
);
